module.exports = __webpack_public_path__ + "static/media/NewLogoWhite2.b72690e1.svg";